import { string, object, array } from 'yup';

export const validationSchema = object().shape({
  id: string().nullable(),
  cremationCertificateNumber: string().nullable(),
  storageLocation: string().nullable(),
  personToReceiveAshes: string().nullable(),
  actions: array().required('There must be at least one completed action.'),
});
